import * as Joi from 'joi';
import { joiResolver } from '@hookform/resolvers/joi';

const signupSchema = Joi.object({
	name: Joi.string()
		.min(3)
		.max(30)
		.error((errors) => {
			errors.forEach((err) => {
				if (err.code === 'string.empty') {
					err.message = 'Name is not allowed to be empty';
				}
			});
			return errors;
		}),
	email: Joi.string()
		.email({
			minDomainSegments: 2,
			tlds: { allow: ['com', 'net'] },
		})
		.error((errors) => {
			errors.forEach((err) => {
				if (err.code === 'string.empty') {
					err.message = 'Email is required field';
				} else if (err.code === 'string.email') {
					err.message = 'Please Enter a valid email';
				}
			});
			return errors;
		}),
	password: Joi.string()
		.min(3)
		.max(15)
		.required()
		.error((errors) => {
			errors.forEach((err) => {
				if (err.code === 'string.empty') {
					err.message = 'Password is required filed';
				} else if (err.code === 'string.min') {
					err.message = 'Password length must be at least 3 characters long';
				} else if (err.code === 'string.max') {
					err.message =
						'Password length must be less than or equal to 15 characters long';
				}
			});
			return errors;
		}),
	repeat_password: Joi.string().required().valid(Joi.ref('password')),
}).error((errors) => {
	// console.log(errors);
	errors.forEach((err) => {
		if (err.code === 'any.only') {
			err.message = 'Password and Repeat Password do not match!';
		}
	});
	return errors;
});
export const signupResolver = joiResolver(signupSchema);
